/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
/**
 * Represents vertex which keeps formula
 */
export class FormulaCellVertex {
    constructor(
    /** Formula in AST format */
    formula, 
    /** Address which this vertex represents */
    cellAddress, version) {
        this.formula = formula;
        this.cellAddress = cellAddress;
        this.version = version;
        this.formula = formula;
        this.cellAddress = cellAddress;
        this.cachedCellValue = null;
    }
    /**
     * Returns formula stored in this vertex
     */
    getFormula(updatingService) {
        this.ensureRecentData(updatingService);
        return this.formula;
    }
    ensureRecentData(updatingService) {
        if (this.version != updatingService.version()) {
            const [newAst, newAddress, newVersion] = updatingService.applyTransformations(this.formula, this.address, this.version);
            this.formula = newAst;
            this.cellAddress = newAddress;
            this.version = newVersion;
        }
    }
    /**
     * Returns address of the cell associated with vertex
     */
    getAddress(updatingService) {
        this.ensureRecentData(updatingService);
        return this.cellAddress;
    }
    get address() {
        return this.cellAddress;
    }
    /**
     * Sets computed cell value stored in this vertex
     */
    setCellValue(cellValue) {
        this.cachedCellValue = cellValue;
    }
    /**
     * Returns cell value stored in vertex
     */
    getCellValue() {
        if (this.cachedCellValue !== null) {
            return this.cachedCellValue;
        }
        else {
            throw Error('Value of the formula cell is not computed.');
        }
    }
    valueOrNull() {
        return this.cachedCellValue;
    }
    isComputed() {
        return (this.cachedCellValue !== null);
    }
}
